<template>
  <div>
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <div class="toolbtn flex">
          <switchcore></switchcore>
          <el-tooltip class="item" effect="dark" content="刷新" placement="top">
            <div @click="refresh()" class="cursorpointer margin-top10">
              <img
                src="@/assets/barsvg/icon／12sx(1).png"
                style="position: relative; top: 2px"
                alt=""
              />
              <span class="f12 pad-left5" style="color: #969eac">刷新</span>
            </div>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="返回" placement="top">
            <callback></callback>
          </el-tooltip>
        </div>
        <!-- 关键词检索  -->
        <div
          class="width100 f14 backwhite border-rd3 flexleft"
          style="min-height: 72px"
          v-if="serchkey"
        >
          <el-form
            ref="ruleForm"
            size="small"
            label-width="100px"
            class="demo-ruleForm width100 flexleft"
          >
            <el-form-item label="资讯分类">
              <el-select
                v-model="inputs"
                placeholder="请选择资讯分类"
                :filterable="true"
              >
                <el-option label="---  请选择  ---" value=""></el-option>
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="资讯关键字">
              <el-input v-model="input" placeholder="  请输入资讯关键字" />
            </el-form-item>
            <div class="margin-left20 margin-top10 margin-bot10">
              <el-button type="primary" @click="submitForm()">检 索</el-button>
              <el-button @click="resetForm()">重 置</el-button>
            </div>
          </el-form>
        </div>

        <div
          class="
            width100
            backwhite
            margin-top15
            pad-top20
            border-rd3
            alldigital
          "
          v-if="total != 0"
        >
          <el-table :data="page" stripe class="eltable width98 margin-auto f14">
            <el-table-column label="标题" align="left"
              ><template slot-scope="scope">
                <span
                  @click="todetails(scope.row)"
                  class="bluecolor cursorpointer"
                  >{{ scope.row.name }}</span
                ></template
              ></el-table-column
            >
            <el-table-column
              label="发布时间"
              align="center"
              prop="create_time"
            />
            <el-table-column
              label="所属分类"
              align="center"
              prop="article_category.name"
            />
            <el-table-column
              label="操作"
              align="center"
              width="220"
              class-name="small-padding fixed-width"
            >
              <template slot-scope="scope">
                <div class="cursorpointer">
                  <span style="color: #52c5cb" @click="todetails(scope.row)"
                    >详情</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div
            class="
              flex-betweennowrap
              pad-top20 pad-bot20
              pagination
              pad-right10
            "
            v-if="total != 0"
          >
            <span></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import { articleindex, articlecategory } from "@/api/newhead/newhead.api";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
import callback from "@/components/callback.vue";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,

      serchkey: true,
      thisNum: 1,
      page: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      input: "",
      inputs: "",
      options: [],
    };
  },

  components: {
    callback,
    switchcore,
  },
  methods: {
    // 详情
    todetails(row) {
      window.sessionStorage.setItem("technologyid", row.id);
      this.$router.push({
        path: "/Industry-Outlook/technology-detail",
      });
    },
    // 第一个分页
    currentchange(val) {
      window.sessionStorage.setItem("articleindexval", val);
      articleindex({
        page: val,
        _keywords: this.input,
        article_category_id: this.inputs,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      articleindex({
        page: 1,
        limit: val,
        _keywords: this.input,
        article_category_id: this.inputs,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.input = null;
      this.inputs = null;
      articleindex({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 关键词检索
    submitForm() {
      if (this.input != "" || this.inputs != "") {
        articleindex({
          _keywords: this.input,
          article_category_id: this.inputs,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    refresh() {
      this.$loading.show(); // 显示loading
      articleindex({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading

          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      articlecategory().then((res) => {
        this.options = res.data.data;
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    if (window.sessionStorage.getItem("articleindexval") == null) {
      this.thisNum = 1;
      this.currentPage1 = 1;
    } else {
      this.thisNum = window.sessionStorage.getItem("articleindexval");
      this.currentPage1 = parseInt(
        window.sessionStorage.getItem("articleindexval")
      );
    }

    articleindex({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    articlecategory().then((res) => {
      this.options = res.data.data;
    });
  },
};
</script>
<style scoped>
.alldigitals {
  height: 80vh;
  overflow-y: scroll;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
</style>